const WHATSAPP_LINK = 'https://wa.me/573057096663?text=Hola%2C%20%C2%BFEn%20qu%C3%A9%20podemos%20ayudarte%3F';

const products = [
  {
    icon: 'ri-settings-3-line',
    title: 'Motores y Culatas',
    color: 'text-blue-400',
    borderColor: 'border-t-blue-500',
    bgIcon: 'bg-blue-500/15',
    items: ['Motores completos', 'Culatas rectificadas', 'Pistones y anillos', 'Cigüeñales y bielas', 'Árbol de levas'],
    imageUrl: 'https://readdy.ai/api/search-image?query=car%20engine%20block%20pistons%20cylinders%20mechanical%20parts%20dark%20background%20professional%20automotive%20photography%20chrome%20metal%20high%20detail&width=600&height=340&seq=prod001&orientation=landscape',
    msg: 'Hola, necesito cotizar motores o culatas. ¿Tienen disponibilidad?',
  },
  {
    icon: 'ri-car-line',
    title: 'Suspensión',
    color: 'text-orange-400',
    borderColor: 'border-t-orange-500',
    bgIcon: 'bg-orange-500/15',
    items: ['Brazos de suspensión', 'Rótulas y terminales', 'Bujes y silentblocks', 'Barras estabilizadoras', 'Muñones y cubos'],
    imageUrl: 'https://readdy.ai/api/search-image?query=car%20suspension%20system%20control%20arms%20ball%20joints%20mechanical%20components%20dark%20studio%20background%20automotive%20parts%20professional%20photography&width=600&height=340&seq=prod002&orientation=landscape',
    msg: 'Hola, necesito cotizar repuestos de suspensión. ¿Tienen disponibilidad?',
  },
  {
    icon: 'ri-arrow-up-down-line',
    title: 'Amortiguadores',
    color: 'text-green-400',
    borderColor: 'border-t-green-500',
    bgIcon: 'bg-green-500/15',
    items: ['Amortiguadores delanteros', 'Amortiguadores traseros', 'Espirales y resortes', 'Kits de reparación', 'Soportes y bases'],
    imageUrl: 'https://readdy.ai/api/search-image?query=car%20shock%20absorbers%20struts%20springs%20mechanical%20parts%20dark%20background%20automotive%20spare%20parts%20professional%20studio%20photography&width=600&height=340&seq=prod003&orientation=landscape',
    msg: 'Hola, necesito cotizar amortiguadores. ¿Tienen disponibilidad?',
  },
  {
    icon: 'ri-tools-line',
    title: 'Transmisión y Embrague',
    color: 'text-red-400',
    borderColor: 'border-t-red-500',
    bgIcon: 'bg-red-500/15',
    items: ['Cajas de cambios', 'Kits de embrague', 'Discos y platos', 'Rodamientos de caja', 'Sincronizadores'],
    imageUrl: 'https://readdy.ai/api/search-image?query=clutch%20kit%20complete%20set%20pressure%20plate%20friction%20disc%20release%20bearing%20automotive%20spare%20parts%20dark%20black%20background%20professional%20studio%20photography%20sharp%20detail%20high%20quality%20metallic%20components&width=600&height=340&seq=prod004clutch&orientation=landscape',
    msg: 'Hola, necesito cotizar repuestos de transmisión o embrague. ¿Tienen disponibilidad?',
  },
  {
    icon: 'ri-speed-line',
    title: 'Sistema de Frenos',
    color: 'text-yellow-400',
    borderColor: 'border-t-yellow-500',
    bgIcon: 'bg-yellow-500/15',
    items: ['Discos de freno', 'Pastillas y zapatas', 'Bombas de freno', 'Calibradores', 'Mangueras de freno'],
    imageUrl: 'https://readdy.ai/api/search-image?query=car%20brake%20discs%20calipers%20brake%20pads%20mechanical%20parts%20dark%20studio%20background%20automotive%20spare%20parts%20professional%20photography&width=600&height=340&seq=prod005&orientation=landscape',
    msg: 'Hola, necesito cotizar repuestos del sistema de frenos. ¿Tienen disponibilidad?',
  },
  {
    icon: 'ri-water-flash-line',
    title: 'Refrigeración y Lubricación',
    color: 'text-cyan-400',
    borderColor: 'border-t-cyan-500',
    bgIcon: 'bg-cyan-500/15',
    items: ['Bombas de agua', 'Radiadores', 'Termostatos', 'Bombas de aceite', 'Juntas y empaques'],
    imageUrl: 'https://readdy.ai/api/search-image?query=car%20cooling%20system%20water%20pump%20radiator%20mechanical%20components%20dark%20background%20automotive%20parts%20professional%20studio%20photography&width=600&height=340&seq=prod006&orientation=landscape',
    msg: 'Hola, necesito cotizar repuestos de refrigeración o lubricación. ¿Tienen disponibilidad?',
  },
];

export default function Products() {
  return (
    <section id="productos" className="bg-[#0d0d0d] py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-6">
          <div className="inline-flex items-center gap-2 border border-[#2563eb]/40 text-[#2563eb] text-xs font-semibold uppercase tracking-widest px-4 py-2 rounded-full mb-4">
            <i className="ri-tools-line"></i>
            Solo Mecánica — Sin Latonería
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4">
            Repuestos <span className="text-[#2563eb]">Mecánicos</span><br />con Disponibilidad Real
          </h2>
          <p className="text-gray-400 text-base max-w-2xl mx-auto mb-3">
            Cotiza por WhatsApp y te confirmamos disponibilidad en minutos. Sin intermediarios, sin esperas innecesarias.
          </p>
          <div className="inline-flex items-center gap-2 bg-red-500/10 border border-red-500/30 text-red-400 text-sm font-semibold px-5 py-2 rounded-full">
            <i className="ri-close-circle-line"></i>
            No trabajamos latonería, pintura ni partes estéticas
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
          {products.map((product) => (
            <div
              key={product.title}
              className={`bg-[#1a1a1a] rounded-xl overflow-hidden border-t-4 ${product.borderColor} group hover:-translate-y-1 transition-transform duration-300`}
            >
              {/* Image */}
              <div className="h-44 overflow-hidden">
                <img
                  src={product.imageUrl}
                  alt={product.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <div className={`w-9 h-9 flex items-center justify-center rounded-lg ${product.bgIcon} flex-shrink-0`}>
                    <i className={`${product.icon} text-lg ${product.color}`}></i>
                  </div>
                  <h3 className="text-white font-bold text-base">{product.title}</h3>
                </div>

                <ul className="space-y-1.5 mb-5">
                  {product.items.map((item) => (
                    <li key={item} className="flex items-center gap-2 text-gray-400 text-sm">
                      <i className={`ri-checkbox-circle-line text-sm ${product.color}`}></i>
                      {item}
                    </li>
                  ))}
                </ul>

                <a
                  href={WHATSAPP_LINK}
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="flex items-center justify-center gap-2 bg-[#2563eb]/10 hover:bg-[#2563eb] border border-[#2563eb]/40 hover:border-[#2563eb] text-[#2563eb] hover:text-white text-sm font-semibold px-4 py-2.5 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer w-full"
                >
                  <i className="ri-whatsapp-line"></i>
                  Cotizar ahora
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
